// extracted by mini-css-extract-plugin
export default {"root":"authLayout_root__xjMDx","logo":"authLayout_logo__xTnum","content":"authLayout_content__lQ4GX"};